import React, { useState, useEffect } from 'react'
import "./PackagesCategoriesList.CSS"
import { Container } from 'react-bootstrap'
import {Header ,PackagesCardList } from "../../Features/PackagesCategoriesList"



const PackagesCategoriesList = ({errorNotFound, pageData, url}) => {


    const [data, setData] = useState([]);
        
         useEffect(()=>{
          if(pageData){
            setData(pageData);
          }

         },[pageData])  

    return (
        <Container className='PackagesCategoriesList-page-container PackagesList-page-container'> 
            <Header pageData={data} />
            <PackagesCardList url={url} pageDataList={data?.content?.categories} errorNotFound={errorNotFound}/>  
        </Container>
    );
}

export default PackagesCategoriesList;
